module.exports = __webpack_public_path__ + "img/smart_product1.21e6d95a.png";